// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_CONTROL_CLIENT_ID,
  PRESUPUESTADOR_CONTROL_CLIENT_ID_ERROR
} from './constants';

export function controlClientId(client) {
  return (dispatch) => {
    const promise = new Promise((resolve, reject) => {
      if (client.id_cliente) {
        dispatch({
          type: PRESUPUESTADOR_CONTROL_CLIENT_ID,
          data: client,
        });
        resolve(true);
      } else {
        dispatch({
          type: PRESUPUESTADOR_CONTROL_CLIENT_ID_ERROR,
          data: { error: "Debe ingresar con un cliente para poder guardar el presupuesto." },
        });
        reject({ error: "Debe ingresar con un cliente para poder guardar el presupuesto." })
      }
    })
    return promise
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_CONTROL_CLIENT_ID:
      // Just after a request is sent
      return state

    case PRESUPUESTADOR_CONTROL_CLIENT_ID_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        controlClientError: action.data.error
      };

    default:
      return state;
  }
}

